module.exports = __webpack_public_path__ + "static-v-shop/1792366500284/img/logo_visadebito.092f0267.png";